"use strict";
var AsyncSubject_1 = require("../AsyncSubject");
var multicast_1 = require("./multicast");
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */
function publishLast() {
    return multicast_1.multicast.call(this, new AsyncSubject_1.AsyncSubject());
}
exports.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/operator/publishLast.js
 ** module id = 366
 ** module chunks = 1
 **/